import allActions from './config.json';
import actionWebInvoke, { getHeaders } from './utils';

class JobManager {

    constructor(storageKey = 'dxpe-voxify') {
      this.oktaAccessToken = 'fake-token';
      this.storageKey = storageKey;
      this.jobs = this._loadFromStorage();
      this.nonce = crypto.randomUUID();

      setInterval(() => {
        this.syncJobs();      
      }, 10000);
    }
  

    async syncJobs() {
        this.nonce = crypto.randomUUID();
        
        this.jobs = this._loadFromStorage();

        const pendingJobs = this.getPendingJobs();
        if (pendingJobs.length === 0) { return; }
      
        const pollResponse = await actionWebInvoke(allActions['poll'],
          getHeaders({}, this.oktaAccessToken),
          { jobIds: pendingJobs.map((job) => job.subJobs.map((subJob) => subJob.id)).flat() }
        ) || [];
      
        pollResponse.forEach(subJob => {
          this.updateJob(subJob.id, subJob);
        });
      
        this.jobs.forEach((job) => {
          job.status = getJobStauts(job);
        });

        this.nonce = crypto.randomUUID();   
    }

    _loadFromStorage() {
      const data = localStorage.getItem(this.storageKey);
      return data ? JSON.parse(data) : [];
    }
  
    _saveToStorage() {
      localStorage.setItem(this.storageKey, JSON.stringify(this.jobs));
    }

    getNonce() {
      return this.nonce;
    }
  
    addJob(nickname, voxifyJobs, text, gender, speechRate) {

      const job = {
        id: crypto.randomUUID(), // unique id for the job 
        nickname: nickname,
        created: Date.now(),
        lastUpdated: Date.now(),
        status: 'pending',
        text,
        gender,
        speechRate,
        subJobs: voxifyJobs.map((voxifyJob) => ({ 
          id: voxifyJob.jobId, 
          status: 'pending',
        }))
      };

      this.jobs.push(job);
      this._saveToStorage();
      return job;
    }
  
    removeJob(jobId) {
      this.jobs = this.jobs.filter(job => job.id !== jobId);
      this._saveToStorage();
    }
  
    updateJob(subJobId, updates) {
      const job = this.jobs.find(job => 
        job.subJobs.some(subJob => subJob.id === subJobId)
      );

      if (job) {
        const subJob = job.subJobs.find(subJob => subJob.id === subJobId);
        Object.assign(subJob, updates, { lastUpdated: Date.now() });


        const completed = job.subJobs.every(sub => sub.status === 'completed');
        const failed = job.subJobs.some(sub => sub.status === 'failed');
        job.status = completed ? 'completed' : (failed ? 'failed' : 'pending');
        job.lastUpdated = Date.now();

        this._saveToStorage();
      }
    }
  
    getJob(jobId) {
      return this.jobs.find(job => job.id === jobId);
    }

    getAllJobs() {
      // Sort by timestamp in descending order (newest first)
      return [...this.jobs].sort((a, b) => b.lastUpdated - a.lastUpdated);
    }
  
    getJobsByStatus(status) {
      return this.jobs.filter(job => job.status === status).sort((a, b) => b.lastUpdated - a.lastUpdated);
    }
  
    getPendingJobs() {
      return this.getJobsByStatus('pending');
    }
  
    getCompletedJobs() {
      return this.getJobsByStatus('completed');
    }
  
    getFailedJobs() {
      return this.getJobsByStatus('failed');
    }

    getExpiredJobs() {
      return this.getJobsByStatus('expired');
    }
  
    updateSubJob(parentJobId, subJobId, updates) {
      const parentJob = this.jobs.find(job => job.id === parentJobId);
      if (parentJob) {
        const subJob = parentJob.subJobs.find(sub => sub.id === subJobId);
        if (subJob) {
          Object.assign(subJob, updates, { lastUpdated: Date.now() });
          parentJob.lastUpdated = Date.now();
          this._saveToStorage();
        }
      }
    }
  }


function getJobStauts(job) {
  // If job.created is over an hour ago, make as "expired"
  const now = Date.now();
  const oneHour = 60 * 60 * 1000;
  
  if (job.status === 'completed' && now - job.lastUpdated > oneHour) {
    // If the job is older than an hour, mark it as expired;
    return 'expired';
  }

  if (job.subJobs.some((subJob => subJob.status === 'failed'))) {
    // If any subjob is failed, mark the job as failed
    return 'failed';
  }

  return job.status;
}


const jobManager = new JobManager();

  
module.exports = jobManager;